import { render, staticRenderFns } from "./PxListaTransportadorList.vue?vue&type=template&id=8ae30002&"
import script from "./PxListaTransportadorList.vue?vue&type=script&lang=js&"
export * from "./PxListaTransportadorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
